import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '../constants';
import { getNumberFormatter } from '../utils/format.utils';

const currencyToLocaleMapping: Record<string, string> = {
  'MXN': 'es-MX',
  'USD': 'es-MX',
};

@Pipe({
  name: 'currencyFormatter',
  standalone: true,
})
export class CurrencyFormatterPipe implements PipeTransform {
  transform(value: number, currency?: string): string {
    const locale = currencyToLocaleMapping[currency ?? constants.defaultCurrency] ?? constants.defaultLocale;
    const formattedValue = getNumberFormatter(locale, {
      currency: currency ?? constants.defaultCurrency,
      style: 'currency',
    }).format(value);
    return `${formattedValue} ${!currency || currency === constants.defaultCurrency ? '' : currency}`;
  }
}
